import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { updateMeetingRecordingName } from "../../../../services/meetingServices";
import logger from '../../../../utils/logger';

const RenameRecordingModal = ({ isOpen, onClose, recording, onSave }) => {
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (recording) {
      setName(recording.name || "");
    }
  }, [recording]);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Name cannot be empty.");
      return;
    }
    setIsSaving(true);
    setError("");
    try {
      await updateMeetingRecordingName({ recordingId: recording.fileId, name });
      onSave(recording.id, name);
      onClose();
    } catch (err) {
      logger("error", "Error updating recording name:", err);
      setError("Failed to update name. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#615B72] rounded-lg shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Rename Recording</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={24} />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label
              htmlFor="recordingName"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Recording Name
            </label>
            <input
              type="text"
              id="recordingName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Enter new name"
            />
          </div>
          {error && <p className="text-red-400 text-sm">{error}</p>}
        </div>
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md text-white bg-gray-600 hover:bg-gray-500 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isSaving}
            className="px-4 py-2 rounded-md text-white bg-purple-600 hover:bg-purple-500 transition disabled:bg-purple-400 disabled:cursor-not-allowed"
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameRecordingModal;
